import React, { useEffect, useContext, useRef, useState, useCallback } from 'react';
import './styles.scss';
import CssBaseline from '@material-ui/core/CssBaseline';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { NotificationManager } from 'react-notifications';
import { Link } from "react-router-dom";
import { useStyles } from './styles';
import { useHistory } from "react-router-dom";
import { SocketContext } from '../../../../Services/socket';
import Cookies from 'universal-cookie';
import { FiSettings, FiLogOut } from 'react-icons/fi';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import 'react-alert-confirm/dist/index.css';
import alertConfirm from 'react-alert-confirm';
import { Header, SideBar, SettingBar } from "../../../Plugin/component";
import { useYbugApi } from 'ybug-react';

const cookies = new Cookies();
var toggleTitle = false;

export default function LayoutComponent(props) {

    const socket = useContext(SocketContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [ShoboxMoreAnchorEl, setShoboxMoreAnchorEl] = React.useState(null);
    const history = useHistory();
    // eslint-disable-next-line
    const [Email, setEmail] = useState(cookies.get('usercode') ? cookies.get('usercode').email : "")
    let interval = useRef();
    // eslint-disable-next-line
    const [rtl, setRtl] = useState(false);
    const [collapsed, setCollapsed] = useState(localStorage.getItem('MenuOnOff') === 'true' ? true : false);
    const [image, setImage] = useState(localStorage.getItem('ImageOnOff') === 'true' ? true : false);
    const [toggled, setToggled] = useState(false);

    const [activeMenu, setActiveMenu] = useState({})
    const [isOpenSetting, setIsOpenSetting] = useState(false)
    const [isOpenMenu, setIsOpenMenu] = useState(true)
    const [imageBackground, setImageBackground] = useState(localStorage.getItem('BackgroundImageId') ? localStorage.getItem('BackgroundImageId') : 1);
    const [count, setCount] = useState(1);
    const YbugContext = useYbugApi();

    const handleCollapsedChange = (checked) => {
        setCollapsed(!collapsed);
        localStorage.setItem('MenuOnOff', !collapsed)
    };

    const handleCollapsedSideBar = (value) => {
        if (value === collapsed) {
            setCollapsed(false)
            localStorage.setItem('MenuOnOff', false)
        } else {
            setCollapsed(true)
            localStorage.setItem('MenuOnOff', true)
        }
    }

    const handleShowSideBar = () => {
        setCollapsed(!collapsed)
    }

    const handleImageChange = (checked) => {
        localStorage.setItem('ImageOnOff', String(!image), { path: '/' })
        setImage(checked);
    };

    const handleToggleSidebar = (value) => {
        setToggled(value);
    };

    const handleClickViewAll = () => {
        //console.log("Hello");
        props.UpdateDataNotification();
        const DataNotiparam = {
            "KeyName": "ITSM"
        };
        props.GetDataNoti(DataNotiparam);
    }

    const HandleActiveMenu = useCallback((item) => {
        const { id, url } = item
        setActiveMenu({ id, url })
        // eslint-disable-next-line
    }, [props.DataLayout])

    const HandleToggleMenu = (e) => {
        setIsOpenMenu(!isOpenMenu)
    }

    const HandleChangeImageBackground = (itemId) => {
        localStorage.setItem('BackgroundImageId', itemId)
        setImageBackground(itemId)
    }
    if (cookies.get('usercode')) {
        var tokene = cookies.get('usercode').token;
        var tokenDecode = jwtDecode(tokene);
        var dateexp = new Date(tokenDecode.exp * 1000);
        var dateCur = new Date();
        if (dateexp < dateCur) {
            if (count === 1) {
                alertConfirm({
                    title: 'WARNING!',
                    content: 'Bạn hết session rồi. Vui lòng đăng nhập lại?',
                    okText: "OK",
                    cancelText: "Cancle",
                    onOk: () => {
                        props.LogOut();
                        //handleMenuClose();
                        // cookies.remove('usercode');
                        // cookies.remove('usercode', { path: '/' });
                        // cookies.remove('KEYCLOAK_SESSION');
                        // cookies.remove('KEYCLOAK_IDENTITY');
                        // cookies.remove('KEYCLOAK_3P_COOKIE_SAMESITE');
                        // cookies.remove('KEYCLOAK_IDENTITY_LEGACY');
                        // cookies.remove('KEYCLOAK_SESSION_LEGACY');
                        // cookies.remove('AUTH_SESSION_ID');
                        // cookies.remove('AUTH_SESSION_ID_LEGACY');
                        // localStorage.removeItem('KeycloakToken');
                        // localStorage.removeItem('keycloakcode');
                        //keycloak.logout();
                        //history.push("/Login");
                    },
                    onCancel: () => {
                        console.log('cancel');
                    }
                });
                setCount(count + 1);
            }
            //props.LogOut();
            //handleMenuClose();
            //cookies.remove('usercode');
            //cookies.remove('usercode', { path: '/' });
            //history.push("/Login");
            //window.location.reload();
            //console.log("Hết hạn rồi nhá bé iu");
        }
        else {
            console.log("Chưa hết hạn");
        }
    }
    useEffect(() => {
        socket.on(cookies.get('usercode').email, (mess) => {
            NotificationManager.success("KH | Bạn có yêu cầu xử lý mới");
            document.title = "KH | Bạn có yêu cầu xử lý mới"
            interval.current = setInterval(() => {
                if (toggleTitle) {
                    document.title = "KH | Bạn có yêu cầu xử lý mới"
                }
                else {
                    document.title = "ITSM"
                }
                toggleTitle = !toggleTitle
            }, 1000);
            const DataNotiparam = {
                "User": cookies.get('usercode').email ? cookies.get('usercode').email : "",
                "UserCode": cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "",
                "KeyName": "ITSM"
            };
            props.GetDataNoti(DataNotiparam);
        });
        const DataNotiparam = {
            "User": cookies.get('usercode').email ? cookies.get('usercode').email : "",
            "UserCode": cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "",
            "KeyName": "ITSM"
        };
        props.GetDataNoti(DataNotiparam);
        props.GetDataLayout()
        window.addEventListener('focus', () => {
            clearInterval(interval.current);
            document.title = "ITSM"
        });
        return () => {
            window.removeEventListener('focus', () => {
                clearInterval(interval.current);
                document.title = "ITSM"
            });
            clearInterval(interval.current);
        }
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.DataNoti && props.DataNoti.length > 0) {
            const DataNoti = JSON.parse(props.DataNoti);
            // eslint-disable-next-line
            DataNoti.map((item, index) => {
                if (item.Flag === 0) {
                    noticount++;
                }
                DSShowbox.push({
                    value: item.PlanID,
                    Name: item.Name.includes('label') ? JSON.parse(item.Name).label : item.Name,
                    NameMain: item.NameMain,
                    Step: item.Step,
                    StepName: item.StepName,
                    Status: item.Status,
                    Flag: item.Flag,
                    CreateDate: item.CreateDate === null || item.CreateDate === undefined ? ' ' : RenderLayout(new Date(item.CreateDate.slice(0, 19).replace('T', ' ')))
                })
            });
        }
        // eslint-disable-next-line
    }, [props.DataNoti]);
    const classes = useStyles();
    const menuId = 'primary-search-account-menu';
    const ShowboxId = 'primary-search-account-menu-mobile';

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleShowboxOpen = (event) => {
        setShoboxMoreAnchorEl(event.currentTarget);
    };
    const handleShowboxClose = () => {
        setShoboxMoreAnchorEl(null);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        handleShowboxClose();
    };

    useEffect(() => {
        if (props.isLogout) {
            cookies.remove('usercode');
            cookies.remove('usercode', { path: '/' });
            localStorage.removeItem('KeycloakToken');
            localStorage.removeItem('keycloakcode');
            if (YbugContext.Ybug) {
                YbugContext.Ybug.hide("launcher");
            }
            //keycloak.logout();
            history.push("/Login");
        }
        // eslint-disable-next-line
    }, [props.isLogout])

    const handleLogOut = () => {
        props.LogOut();
        //keycloak.logout();
        //handleMenuClose();
        // cookies.remove('usercode');
        // cookies.remove('usercode', { path: '/' });
        // cookies.remove('KEYCLOAK_SESSION');
        // cookies.remove('KEYCLOAK_IDENTITY');
        // cookies.remove('KEYCLOAK_3P_COOKIE_SAMESITE');
        // cookies.remove('KEYCLOAK_IDENTITY_LEGACY');
        // cookies.remove('KEYCLOAK_SESSION_LEGACY');
        // cookies.remove('AUTH_SESSION_ID');
        // cookies.remove('AUTH_SESSION_ID_LEGACY');
        // localStorage.removeItem('KeycloakToken');
        // localStorage.removeItem('keycloakcode');
        //history.push("/Login");
        // window.location.reload();
    };
    const handleclickNoti = (PlanID) => {
        props.SetDataLayout(PlanID);
        const DataNotiparam = {
            "User": cookies.get('usercode').email ? cookies.get('usercode').email : "",
            "UserCode": cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "",
            "KeyName": "ITSM"
        };
        props.GetDataNoti(DataNotiparam);
        handleShowboxClose();
    };
    const isMenuOpen = Boolean(anchorEl);
    const isShowboxOpen = Boolean(ShoboxMoreAnchorEl);
    const DSShowbox = [];
    let noticount = 0;
    if (props.DataNoti && props.DataNoti.length > 0) {
        const DataNoti = JSON.parse(props.DataNoti);
        // eslint-disable-next-line
        DataNoti.map((item, index) => {
            if (item.Flag === 0) {
                noticount++;
            }
            DSShowbox.push({
                value: item.PlanID,
                Name: item.Name.includes('label') ? JSON.parse(item.Name).label : item.Name,
                NameMain: item.NameMain,
                Step: item.Step,
                StepName: item.StepName,
                Status: item.Status,
                Flag: item.Flag,
                CreateDate: item.CreateDate === null || item.CreateDate === undefined ? ' ' : RenderLayout(new Date(item.CreateDate.slice(0, 19).replace('T', ' ')))
            })
        });
    }
    function RenderLayout(date) {
        var currentDate = moment(new Date());
        var inputDate = moment(date);
        var minute = currentDate.diff(inputDate, "minutes");
        var hours = Math.round(minute / 60);
        var day = Math.round(hours / 24);
        var week = Math.round(day / 7);
        if (minute === 0) {
            return 'Mới';
        }
        else if (minute < 60) {
            return minute + ' phút trước';
        }
        else if (hours >= 1 && hours <= 23) {
            return hours + ' giờ trước';
        }
        else if (day < 7) {
            return day + ' ngày trước';
        }
        else if (week >= 1) {
            return week + ' tuần trước';
        }
    }

    const handleShowSetting = () => {
        setIsOpenSetting(true)
    }

    const HandleCloseSetting = () => {
        setIsOpenSetting(false)
        handleMenuClose()
    }

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            id={menuId}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem ><IconButton aria-label="show new notifications" key={1} color="inherit"><AccountCircle />
            </IconButton><div>{Email}</div></MenuItem>
            <MenuItem onClick={handleShowSetting}>
                <ListItem>
                    <ListItemIcon>< FiSettings /></ListItemIcon>
                    <ListItemText>Setting</ListItemText>
                </ListItem>
            </MenuItem>
            <MenuItem onClick={handleLogOut}>
                <ListItem>
                    <ListItemIcon>< FiLogOut /></ListItemIcon>
                    <ListItemText>Logout</ListItemText>
                </ListItem>
            </MenuItem>
        </Menu>
    );
    // var date = moment(new Date());
    // var date1 = moment(new Date('2022-05-18 14:24:15.053'));
    // var datedff = date.diff(date1, "minutes");
    // console.log("minute", datedff/60);
    const renderShowbox = (
        <div style={{ position: "absolute", top: 0, bottom: 0 }}>
            <Menu
                anchorEl={ShoboxMoreAnchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                id={ShowboxId}
                keepMounted
                open={isShowboxOpen}
                onClose={handleShowboxClose}
            >
                <div className='row' style={{ display: "flex" }} key="1">
                    <div className="HearderNoti col-7" style={{ paddingLeft: '43px' }}>Thông Báo</div>
                    <IconButton className="iconnoti col-5" onClick={() => handleClickViewAll()} aria-label="show new notifications" key="1" color="inherit">
                        <Badge color="secondary" style={{ fontSize: '13px' }}>
                            Đánh dấu đã đọc
                        </Badge>
                    </IconButton>
                </div>
                {DSShowbox.map((item, index) => <Link className="hrefnoti" key={index} onClick={() => handleclickNoti(item.value)} to={"/PlanHandle/PlanHandleStep/" + item.value}>
                    <MenuItem key={index} style={item.Flag === 0 ? { backgroundColor: '#e9f3ff', fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` } : { backgroundColor: '#fff', fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` }}>
                        <IconButton aria-label="show new notifications" key={index} color="inherit">
                            <Badge color="secondary" variant="dot" invisible={item.Flag === 0 ? false : true}>
                                <NotificationsIcon style={{ color: "var(--itsm-bg-icon-blue)" }} />
                            </Badge>
                        </IconButton>
                        <div><div className="c" style={item.Flag === 0 ? { color: "#000", fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` } : { color: "#696969", fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` }}><b>{item.NameMain}</b></div>
                            <div className="Itemlabel1" style={item.Flag === 0 ? { color: "var(--itsm-text-color-blue)", fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` } : { color: "#696969", fontFamily: `'Nunito Sans', 'Poppins', sans-serif  !important` }}>
                                <span>{item.Name} </span><br /><span> {"Bước " + item.Step + " :" + item.StepName}</span><br />
                                <small>{" " + item.CreateDate}</small>
                            </div>
                        </div>
                    </MenuItem></Link>
                )}
            </Menu>
        </div>
    );
    return (
        <div className={classes.root} styles={{ display: "flex", flexDirection: "row" }}>
            <SideBar
                image={image}
                collapsed={collapsed}
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
                handleCollapsedChange={handleCollapsedChange}
                props={props}
                activeMenu={activeMenu}
                handleOnClick={HandleActiveMenu}
                handleCollapsedSideBar={handleCollapsedSideBar}
                open={isOpenMenu}
                HandleToggleMenu={HandleToggleMenu}
                imageBackground={imageBackground}
            ></SideBar>
            <CssBaseline />
            <Header
                handleShowSideBar={handleShowSideBar}
                handleShowboxOpen={handleShowboxOpen}
                handleProfileMenuOpen={handleProfileMenuOpen}
                noticount={noticount}
            ></Header>
            <main className={classes.content}>
                {/* <Toolbar /> */}
                {props.children}
            </main>
            {!isOpenSetting && renderShowbox}
            {!isOpenSetting && renderMenu}
            {isOpenSetting && <div className={classes.SettingContanier}>
                <SettingBar
                    image={image}
                    collapsed={collapsed}
                    rtl={rtl}
                    toggled={toggled}
                    handleToggleSidebar={handleToggleSidebar}
                    handleCollapsedChange={handleCollapsedChange}
                    props={props}
                    activeMenu={isOpenSetting}
                    handleOnClick={HandleActiveMenu}
                    handleImageChange={handleImageChange}
                    HandleCloseSetting={HandleCloseSetting}
                    imageBackground={imageBackground}
                    HandleChangeImageBackground={HandleChangeImageBackground}
                >
                </SettingBar>
            </div>}
        </div>
    );
}
